/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Formfields_Copytoall3Inputs */

const en_formfields_copytoall3 = /** @type {(inputs: Formfields_Copytoall3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Copy to all`)
};

/**
* | output |
* | --- |
* | "Copy to all" |
*
* @param {Formfields_Copytoall3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const formfields_copytoall3 = /** @type {((inputs?: Formfields_Copytoall3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Formfields_Copytoall3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_formfields_copytoall3(inputs)
});
export { formfields_copytoall3 as "formFields_copyToAll" }